<template>
    <div class="nuevas">
        <div class="box-list">
            <center>
                <h3>Lista modelos nuevas</h3>
                <table v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="100">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Nombre</th>
                            <th>Apellido</th>
                            <th>Tipo de documento</th>
                            <th>Documento</th>
                            <th>Balance</th>
                            <th>Turno</th>
                            <th>Tipo de modelo</th>
                            <th>Perfil</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in list" :key="index">
                            <td>{{++index}}</td>
                            <td>{{item.name}}</td>
                            <td>{{item.lastname}}</td>
                            <td>{{item.document_type}}</td>
                            <td>{{item.document}}</td>
                            <td>{{priceFormat(item.balance)}}</td>
                            <td>{{item.turno}}</td>
                            <td>{{item.model_type === true ? 'STUDIO' : 'SATELITE'}}</td>
                            <td><button @click="$router.push('/modelo/' + item.id + '/profile')">ver perfil</button></td>
                        </tr>
                    </tbody>
                </table>
            </center>
        </div>
    </div>
</template>

<script>
import API from '@/api'
import Price from '@/utils/ConvertPriceNumber'

export default {
    name: 'nuevas',
    data() {
        return {
            list: [],
            limit: 20,
            offset: 0,
            busy: false,
            listEnd: false,
            itemFlag: false
        }
    },
    beforeMount() {
        this.$root.$emit('changeList', this.$route.name)
    },
    methods: {
        priceFormat: function(item) {
            return Price(item)
        },
        getNewList() {
            API.getNewList(this.limit, this.offset)
                .then((res) => {
                    res.map(item => { this.list.push(item) })
                    this.offset += this.limit
                    this.itemFlag = true
                })
        },
        loadMore() {
            this.busy = true
            if (!this.listEnd) {
                setTimeout(() => {
                    if (this.list.length < this.offset) {
                        this.listEnd = true
                        return
                    }
                    if (this.itemFlag) {
                        this.getNewList()
                        this.busy = false
                    } else {
                        this.loadMore()
                    }
                }, 1000)
            }
        }
    },
    mounted() {
        this.getNewList()
    }
}
</script>

<style scoped>
.nuevas {
    background-color: #cdcdcd;
    min-height: 78vh;
    padding: 20px;
}
.nuevas > .box-list {
    background: #585858;
    background-color: #585858;
    width: 100%;
    padding: 20px;
    height: 72vh;
    border-radius: 20px;
    border-style: outset;
}
.nuevas > .box-list > center {
    padding: 30px;
    overflow-y: auto;
    height: 70vh;
}
.nuevas > .box-list > center > table {
    margin-top: 30px;
    border-radius: 20px;
}
.nuevas > .box-list > center > table > thead > tr {
    text-align: center;
    color: #fff;
    font-weight: bold;
    background-color: #3a88b5;
}
.nuevas > .box-list > center > table > thead > tr > th {
    padding: 30px;
    border-style: double;
}
.nuevas > .box-list > center > table > tbody > tr {
    text-align: center;
    color: #fff;
    font-weight: bold;
}
.nuevas > .box-list > center > table > tbody > tr > td {
    padding: 10px;
    border-style: double;
}
.nuevas > .box-list > center > table > tbody > tr > td > button {
   background-color: #e0b059;
    color: #fff;
    min-width: 50px;
    height: auto;
    border-radius: 30px;
    width: 200px;
    padding: 10px;
}
.nuevas > .box-list > center > h3 {
    color:#fff
}

</style>



// WEBPACK FOOTER //
// src/components/Modelos/Listas/NewList.vue